// This is the result of https://embroidery.documents.cimpress.io/threads
// simplified for faster lookup and to remove names
export const EMBROIDERY_THREAD_COLORS = {
    mcp0015: "#FFFFFF",
    mcp0020: "#282E2E",
    mcp0108: "#7F878B",
    mcp0132: "#4A555D",
    mcp0145: "#C5D3DA",
    mcp0520: "#F4E79F",
    mcp0600: "#FAD815",
    mcp0672: "#C3BDA7",
    mcp0703: "#FFCC46",
    mcp0721: "#B38533",
    mcp0747: "#655330",
    mcp0776: "#776F62",
    mcp0853: "#977F5E",
    mcp0931: "#B06A23",
    mcp0933: "#6D4A2F",
    mcp1060: "#F1DABB",
    mcp1141: "#CEA984",
    mcp1172: "#CFBFA0",
    mcp1300: "#F66B29",
    mcp1904: "#AF2529",
    mcp1950: "#E34D79",
    mcp2113: "#6C2431",
    mcp2153: "#C68494",
    mcp2300: "#B92860",
    mcp2363: "#F7DEEA",
    mcp2508: "#BC3F88",
    mcp2550: "#E49CC4",
    mcp2830: "#9377B1",
    mcp2905: "#604D99",
    mcp3110: "#383574",
    mcp3241: "#8C91B1",
    mcp3323: "#263663",
    mcp3544: "#174D95",
    mcp3640: "#99BDE8",
    mcp3743: "#2F506B",
    mcp3902: "#0B72A7",
    mcp3962: "#A7DBF2",
    mcp4111: "#43B5CD",
    mcp4610: "#3EA19C",
    mcp5050: "#B8E4DD",
    mcp5220: "#93D7B9",
    mcp5324: "#245E41",
    mcp5500: "#7CE553",
    mcp5510: "#4BA044",
    mcp5664: "#6D8173",
    mcp6031: "#C9D000",
    mcp6051: "#BFCF93",
    mcp6133: "#887A31",
    mcp3574: "#141832",
    mcp0870: "#CEC8C1",
    mcp0861: "#928474",
    mcp2115: "#40192B",
    mcp0131: "#E3DDE1",
    mcp2155: "#FFAAC7",
    mcp5866: "#013300",
    mcp0003: "#FBFBFB",
    mcp0010: "#FFFFFA",
    mcp0017: "#F8FFFF",
    mcp0101: "#FFFFE8",
    mcp0105: "#ACB4B7",
    mcp0111: "#54615E",
    mcp0112: "#757075",
    mcp0124: "#F0F3F3",
    mcp0128: "#4A574D",
    mcp0134: "#121C1B",
    mcp0138: "#515A5F",
    mcp0142: "#CCD1CF",
    mcp0150: "#F0F0E1",
    mcp0151: "#EBE8DC",
    mcp0152: "#827887",
    mcp0170: "#C0B69D",
    mcp0176: "#D0D5D9",
    mcp0182: "#E3DCF0",
    mcp0184: "#F8EEFD",
    mcp0220: "#F9EE3C",
    mcp0221: "#F0FF42",
    mcp0230: "#FEE459",
    mcp0232: "#D9FF78",
    mcp0250: "#F8F8C0",
    mcp0270: "#FFFFE3",
    mcp0310: "#FFFF70",
    mcp0311: "#FFEE0F",
    mcp0345: "#8C972E",
    mcp0352: "#C5E866",
    mcp0442: "#A6BD28",
    mcp0453: "#85AE4C",
    mcp0454: "#455926",
    mcp0463: "#80C291",
    mcp0465: "#264000",
    mcp0501: "#FFFF00",
    mcp0504: "#FBD100",
    mcp0506: "#FFEE23",
    mcp0532: "#EEE67A",
    mcp0542: "#D9D71E",
    mcp0546: "#CCD700",
    mcp0552: "#C2B851",
    mcp0555: "#6D7E6B",
    mcp0576: "#141615",
    mcp0605: "#FFF000",
    mcp0608: "#FFF00C",
    mcp0622: "#CFC07D",
    mcp0630: "#FFFAB3",
    mcp0640: "#FFFA91",
    mcp0643: "#BCA66C",
    mcp0651: "#FFF3B0",
    mcp0660: "#FDFDCA",
    mcp0670: "#FDFDD7",
    mcp0674: "#4B554A",
    mcp0700: "#FFE81E",
    mcp0702: "#F8E305",
    mcp0704: "#FFE600",
    mcp0713: "#FFF354",
    mcp0722: "#C5B580",
    mcp0731: "#B28659",
    mcp0741: "#D4C85C",
    mcp0761: "#FFFFCF",
    mcp0763: "#686A54",
    mcp0771: "#C4BAA1",
    mcp0781: "#EEDDBF",
    mcp0800: "#FFD305",
    mcp0811: "#FFD930",
    mcp0821: "#F5D423",
    mcp0822: "#E8DE40",
    mcp0824: "#EED90C",
    mcp0832: "#F0D74C",
    mcp0842: "#CAAE21",
    mcp0851: "#FFD970",
    mcp0862: "#CCC59C",
    mcp0873: "#CAC58F",
    mcp0874: "#D9CCB0",
    mcp0904: "#F8BE00",
    mcp0922: "#E3C01C",
    mcp0932: "#DC9C11",
    mcp0934: "#C0A342",
    mcp0940: "#E6CA00",
    mcp0941: "#C2B02B",
    mcp0945: "#614A21",
    mcp0970: "#FFFFCC",
    mcp1010: "#DD9644",
    mcp1030: "#E3AF42",
    mcp1032: "#7E541A",
    mcp1055: "#543A1E",
    mcp1061: "#DCB86E",
    mcp1102: "#ED9206",
    mcp1106: "#FF4C00",
    mcp1114: "#FF942E",
    mcp1115: "#CC730A",
    mcp1120: "#FF9700",
    mcp1123: "#C0AE5E",
    mcp1133: "#A27440",
    mcp1134: "#7A471E",
    mcp1140: "#FFF5A8",
    mcp1154: "#8F4F00",
    mcp1161: "#C1B293",
    mcp1200: "#D5760C",
    mcp1220: "#FF992B",
    mcp1233: "#7E4C29",
    mcp1252: "#AE7F23",
    mcp1301: "#E84200",
    mcp1304: "#F04700",
    mcp1305: "#FF4F00",
    mcp1306: "#FF0000",
    mcp1310: "#E45A00",
    mcp1311: "#CF5705",
    mcp1312: "#B53000",
    mcp1321: "#C54915",
    mcp1332: "#E67528",
    mcp1334: "#AE2E0C",
    mcp1335: "#B83511",
    mcp1342: "#AB5400",
    mcp1344: "#9A5720",
    mcp1346: "#380000",
    mcp1351: "#FFBB7D",
    mcp1352: "#FFA65C",
    mcp1355: "#4F0000",
    mcp1362: "#FFD459",
    mcp1366: "#260000",
    mcp1375: "#2B2330",
    mcp1430: "#FA853A",
    mcp1514: "#C02B00",
    mcp1521: "#F37854",
    mcp1526: "#7B352D",
    mcp1532: "#FFB49B",
    mcp1543: "#7C4D45",
    mcp1565: "#8A683A",
    mcp1600: "#E37A4A",
    mcp1701: "#E83300",
    mcp1703: "#FF2621",
    mcp1704: "#FF1E0C",
    mcp1720: "#D82B2D",
    mcp1725: "#CA4726",
    mcp1730: "#F26B6F",
    mcp1753: "#EB5E6F",
    mcp1755: "#F0CCEB",
    mcp1760: "#F0CCC0",
    mcp1761: "#EEBDA1",
    mcp1776: "#322E2D",
    mcp1800: "#D90211",
    mcp1805: "#DE1135",
    mcp1840: "#FF9E80",
    mcp1860: "#FFE1EE",
    mcp1874: "#544245",
    mcp1876: "#2E1700",
    mcp1900: "#D7002B",
    mcp1902: "#A80000",
    mcp1903: "#DE0005",
    mcp1906: "#AE000A",
    mcp1911: "#940014",
    mcp1912: "#470005",
    mcp1913: "#97003A",
    mcp1921: "#AB4C4C",
    mcp1940: "#FF3DDC",
    mcp1972: "#B5B5B5",
    mcp2011: "#99213A",
    mcp2022: "#804540",
    mcp2051: "#D791BA",
    mcp2101: "#A30030",
    mcp2123: "#401414",
    mcp2152: "#EB709E",
    mcp2160: "#FDD7F5",
    mcp2170: "#F8DEEB",
    mcp2171: "#FDE3FF",
    mcp2211: "#660729",
    mcp2220: "#F8517A",
    mcp2222: "#7D0026",
    mcp2224: "#85282B",
    mcp2241: "#B36675",
    mcp2250: "#FDD7FA",
    mcp2320: "#D42E9C",
    mcp2333: "#611733",
    mcp2336: "#30020F",
    mcp2500: "#7A0054",
    mcp2504: "#A6307A",
    mcp2506: "#66002B",
    mcp2510: "#D090C2",
    mcp2520: "#F038C5",
    mcp2521: "#E121B5",
    mcp2530: "#F486B3",
    mcp2560: "#FF91F0",
    mcp2564: "#4A5859",
    mcp2600: "#9747A8",
    mcp2640: "#DC8AFF",
    mcp2650: "#E1C0F8",
    mcp2655: "#EED1FA",
    mcp2674: "#A6B5B3",
    mcp2702: "#231B4C",
    mcp2704: "#580057",
    mcp2711: "#59003A",
    mcp2715: "#470019",
    mcp2721: "#A04686",
    mcp2723: "#8E165E",
    mcp2732: "#97408E",
    mcp2761: "#EDD8DF",
    mcp2762: "#B4AAB2",
    mcp2764: "#D180C2",
    mcp2776: "#171B1C",
    mcp2810: "#8C2B68",
    mcp2832: "#755FB2",
    mcp2864: "#35354F",
    mcp2900: "#4C0073",
    mcp2910: "#BD54D9",
    mcp2912: "#B08BC1",
    mcp2920: "#AB66A3",
    mcp2944: "#332232",
    mcp2953: "#171D3F",
    mcp2954: "#111820",
    mcp3030: "#9483B9",
    mcp3040: "#C7A8F8",
    mcp3045: "#CF99FF",
    mcp3102: "#00004F",
    mcp3114: "#3A0054",
    mcp3130: "#8A8DC2",
    mcp3150: "#8087B1",
    mcp3151: "#5F8AC1",
    mcp3210: "#610091",
    mcp3211: "#9E4F9C",
    mcp3251: "#C79CD9",
    mcp3265: "#283A3E",
    mcp3274: "#51646B",
    mcp3331: "#C5ABF0",
    mcp3332: "#3C5B9E",
    mcp3333: "#280066",
    mcp3335: "#450585",
    mcp3344: "#00002E",
    mcp3350: "#CAD6F0",
    mcp3353: "#2B0A73",
    mcp3355: "#00074F",
    mcp3363: "#001D2D",
    mcp3410: "#3B67A6",
    mcp3444: "#0A3342",
    mcp3450: "#989CCB",
    mcp3510: "#002E7B",
    mcp3522: "#054ABD",
    mcp3536: "#5E0F54",
    mcp3541: "#68008F",
    mcp3543: "#470091",
    mcp3554: "#00000A",
    mcp3572: "#9CACB9",
    mcp3600: "#004AA6",
    mcp3611: "#0C3A8C",
    mcp3612: "#8273B3",
    mcp3620: "#0067B2",
    mcp3622: "#00359E",
    mcp3630: "#7AADE6",
    mcp3631: "#185493",
    mcp3641: "#5E87EE",
    mcp3644: "#003957",
    mcp3645: "#0C2E47",
    mcp3650: "#EBE8FF",
    mcp3652: "#A1CCF8",
    mcp3654: "#3A526C",
    mcp3666: "#081F2C",
    mcp3710: "#007FD3",
    mcp3711: "#0083C0",
    mcp3713: "#05539B",
    mcp3730: "#99C6EF",
    mcp3732: "#001C73",
    mcp3750: "#D4E6FF",
    mcp3761: "#D7E6FD",
    mcp3762: "#6EA6BD",
    mcp3770: "#F5F5EB",
    mcp3810: "#5470D4",
    mcp3815: "#6BA8FF",
    mcp3820: "#A6D1FF",
    mcp3830: "#5397BC",
    mcp3840: "#D1D7FA",
    mcp3842: "#30788A",
    mcp3852: "#486F7E",
    mcp3853: "#3F758F",
    mcp3900: "#2B91F8",
    mcp3901: "#14A1FF",
    mcp3906: "#00AADF",
    mcp3910: "#ABE6E3",
    mcp3920: "#4EC4F4",
    mcp3951: "#B8D1E1",
    mcp3953: "#476E87",
    mcp3963: "#C8E5F5",
    mcp3971: "#E8E8E6",
    mcp4010: "#05CAD7",
    mcp4032: "#519CAE",
    mcp4071: "#E8F8FF",
    mcp4073: "#9C9C9C",
    mcp4074: "#475A61",
    mcp4101: "#68E6E8",
    mcp4103: "#00C5EE",
    mcp4113: "#4AD4D7",
    mcp4116: "#0CA8B3",
    mcp4122: "#00C0E4",
    mcp4133: "#00475E",
    mcp4152: "#7FB6BB",
    mcp4174: "#00232E",
    mcp4220: "#8AF0EE",
    mcp4230: "#A8F3F0",
    mcp4240: "#B3FFFD",
    mcp4250: "#D7FFFA",
    mcp4332: "#4094AC",
    mcp4410: "#0AA682",
    mcp4421: "#00C7B5",
    mcp4423: "#07B89E",
    mcp4430: "#91EBE8",
    mcp4515: "#005151",
    mcp4531: "#00B091",
    mcp4620: "#4CE8AE",
    mcp4625: "#30B882",
    mcp4643: "#0C8580",
    mcp4644: "#00635C",
    mcp4740: "#97CED5",
    mcp4752: "#84ABA6",
    mcp4952: "#92CFC7",
    mcp5005: "#23AB61",
    mcp5010: "#00E1A8",
    mcp5100: "#11C254",
    mcp5101: "#3AD497",
    mcp5115: "#8AEEB0",
    mcp5210: "#1EEB6E",
    mcp5233: "#02AE6E",
    mcp5326: "#008021",
    mcp5335: "#005C11",
    mcp5374: "#005130",
    mcp5400: "#00B282",
    mcp5411: "#00CF00",
    mcp5415: "#11CC00",
    mcp5422: "#00B300",
    mcp5440: "#81DF93",
    mcp5450: "#A6D9B0",
    mcp5513: "#2ED100",
    mcp5515: "#07E300",
    mcp5531: "#59E640",
    mcp5542: "#417C6A",
    mcp5552: "#ABD9A1",
    mcp5555: "#005E00",
    mcp5565: "#224F32",
    mcp5610: "#8FF533",
    mcp5613: "#4CFA2B",
    mcp5633: "#19AB19",
    mcp5643: "#0F9100",
    mcp5650: "#B5FF8A",
    mcp5722: "#00874F",
    mcp5730: "#98D19C",
    mcp5740: "#C0CED1",
    mcp5743: "#2E6444",
    mcp5770: "#A1D9CE",
    mcp5822: "#B3E36B",
    mcp5830: "#8ECB52",
    mcp5832: "#5DA64A",
    mcp5833: "#66D721",
    mcp5912: "#8CFF42",
    mcp5933: "#2EAB00",
    mcp5934: "#358200",
    mcp5940: "#91FF21",
    mcp5944: "#196811",
    mcp6010: "#D7EB00",
    mcp6011: "#BCCD40",
    mcp6043: "#52771A",
    mcp6071: "#AEC09A",
    mcp6141: "#7EB192",
    mcp6151: "#ECEDB1",
    mcp6156: "#1E3500",
    mcp9001: "#89764B",
};
//# sourceMappingURL=threadColors.js.map